import HeroArticleHeaderApi from './HeroArticleHeaderApi';
export default HeroArticleHeaderApi;
